<template>
  <div class="qyxxbgLookFather">
    <qyxxbg-look-1 id="jbxx" :dw-bgjl-dto="dwBgjlDto" />
    <qyxxbg-look-2 id="faren" :fr-bgjl-dto="frBgjlDto" />
    <qyxxbg-look-3
      id="hxp"
      ref="child3"
      :hxp-bgjl-dtos="hxpBgjlDtos"
      :fjmk-info-dtos="fjmkInfoDtos"
      :sphj-dto-list="sphjDtoList"
    />
    <div :style="navigationStyle()" class="navigation">
      <img
        v-for="(item, index) in navigationImg"
        :key="index"
        v-preventReClick
        :style="navigationItemStyle(item.flag, item.ref)"
        :src="item.flag ? item.img1 : item.img2"
        @click="change(item)"
      >
    </div>
  </div>
</template>
<script>
import { lookDraft } from '@/assets/js/qyxxbg.js'
import QyxxbgLook1 from './qyxxbgLook1.vue'
import qyxxbgLook2 from './qyxxbgLook2.vue'
import QyxxbgLook3 from './qyxxbgLook3.vue'
export default {
  components: { QyxxbgLook1, qyxxbgLook2, QyxxbgLook3 },
  props: { LookId: String },
  data() {
    return {
      heightWindow: null,
      widthWindow: null,
      dwBgjlDto: {
        // 单位变更
        id: '', // 主键
        dwmc: '', // 单位名称
        shtyxydm: '', // 社会统一信用代码
        dwxz: '1', // 单位性质
        dwlx: '', // 单位类型
        dwzs: '', // 单位住所
        frmc: '', // 法人/经营者名称
        zczb: '', // 注册资本
        zczbDw: '', // 注册资本
        clrq: '', // 成立日期
        fzjg: '',
        zhxs: '',
        yyqxKs: '', // 营业期限开始
        yyqxJs: '', // 营业期限结束
        jyfw: '', // 经营范围
        dwzj: '', // 单位座机
        dwsj: '', // 单位手机
        sjjyd: '', // 实际经营地
        cyrysl: '', // 从业人员数量
        st: '', // 省厅
        sj: '', // 市局
        qxj: '', // 区县级
        pcs: '', // 派出所
        provinceLabel: '',
        cityLabel: '',
        countyLabel: '',
        sjProvinceLabel: '',
        sjCityLabel: '',
        sjCountyLabel: '',
        by2: '', // 货币
        yyzzUrl: '', // 营业执照路径
        YyqxDate: [] // 营业执照路径
      },
      frBgjlDto: {
        // 法人/经营者变更
        id: '',
        dwid: '',
        xm: '',
        zw: '',
        jg: '',
        sjzz: '',
        bgdh: '',
        sjhm: '',
        zjlx: '1',
        qtzj: '',
        zjhm: '',
        xb: '',
        mz: '',
        sr: '',
        jgLabel: '',
        yxqxKs: '',
        yxqxJs: '',
        fzjg: '',
        zjzpZm: '2021/11/12/a674bdfc-3b83-4c0b-8a0c-f05ffe74042f.jpg',
        zjzpFm: '2021/11/12/3d71d32f-e44a-42f9-b642-061b0f385d78.jpg',
        yxqxDate: ''
      },
      hxpBgjlDtos: [], // 化学品
      fjmkInfoDtos: [], // 附件
      sphjDtoList: [], // 审批结果
      navigationImg: [
        {
          ref: 1,
          img1: require('@/assets/img/jbxxbg1.png'),
          img2: require('@/assets/img/jbxxbg2.png'),
          flag: true
        },
        {
          ref: 2,
          img1: require('@/assets/img/frxxbg1.png'),
          img2: require('@/assets/img/frxxbg2.png'),
          flag: false
        },
        {
          ref: 3,
          img1: require('@/assets/img/zzzj1.png'),
          img2: require('@/assets/img/zzzj2.png'),
          flag: false
        }
      ]
    }
  },
  computed: {},
  watch: {},
  created() {
    window.addEventListener('resize', this.GetWindowInfo)
    this.GetWindowInfo() // 页面创建时先调用一次
  },
  mounted() {
    this.loadFormData() // 加载各个组件的数据
  },
  beforeDestroy() {},
  methods: {
    loadFormData() {
      // 查看todo
      lookDraft(this.LookId).then((e) => {
        const data = e.data.data
        this.dwBgjlDto = data.compareDwBgjlDto
        this.frBgjlDto = data.compareFrBgjlDto
        this.hxpBgjlDtos = data.compareHxpBgjlDtos
        this.fjmkInfoDtos = data.compareFjmkInfoDtos
        this.sphjDtoList = data.sphjDtoList
        if (data.hasOwnProperty('dwFjlxZl')) {
          this.$refs.child3.haveDwFjlxZl = data.dwFjlxZl
        }
      })
    },
    navigationStyle() {
      return {
        top: '200px',
        right: this.widthWindow * 0.03 + 'px'
      }
    },
    navigationItemStyle(flag, ref) {
      if (ref == 3) {
        if (flag) {
          return {
            width: '207px',
            height: '56px',
            position: 'relative',
            left: '-10px'
          }
        }
        return {
          width: '207px',
          height: '56px'
        }
      } else {
        if (flag) {
          return {
            width: '171px',
            height: '56px',
            position: 'relative',
            left: '-10px'
          }
        }
        return {
          width: '171px',
          height: '56px'
        }
      }
    },
    change(item) {
      this.navigationImg.forEach((element) => {
        element.flag = false
      })
      item.flag = true
      switch (item.ref) {
        case 1:
          document
            .querySelector('#jbxx')
            .scrollIntoView({ block: 'start', behavior: 'smooth' })
          break
        case 2:
          document
            .querySelector('#faren')
            .scrollIntoView({ block: 'start', behavior: 'smooth' })
          break
        case 3:
          document
            .querySelector('#hxp')
            .scrollIntoView({ block: 'start', behavior: 'smooth' })
          break
      }
    },
    GetWindowInfo() {
      this.widthWindow = window.innerWidth // 宽
      this.heightWindow = window.innerHeight // 高
    }
  }
}
</script>
<style lang="less" scoped>
.qyxxbgLookFather {
  /* width: 90%;
  margin: auto;
  max-width: 1200px; */
  position: relative;
  .navigation {
    position: fixed;
    z-index: 10;
    width: 150px;
  }
}
</style>
